<script>
import MasterRoomInfo from '@components/master-room-info'
import MasterRoomOffer from '@components/master-room-offer'

export default {
  components: { MasterRoomInfo, MasterRoomOffer },
  props: {
    room: { type: Object, required: true },
    index: { type: Number, required: true },
  },
}
</script>

<template>
  <div class="border border-gray-500 mb-6">
    <div class="py-4 px-3">
      <a class="font-medium cursor-pointer hover:underline">{{ room.name }}</a>
    </div>
    <div class="bg-gray-100">
      <div class="flex flex-wrap">
        <MasterRoomInfo :room="room" />
        <MasterRoomOffer :room="room" :room-index="index" />
      </div>
    </div>
  </div>
</template>
